import React, { useState } from 'react';

const MAX_ITEM_LENGTH = 60;
const MAX_ITEMS = 20;

const EditableItemList = ({ items, onChange, placeholder = 'Add item' }) => {
  const [draftItem, setDraftItem] = useState('');
  const [error, setError] = useState('');

  const addItem = () => {
    const nextItem = draftItem.trim();

    if (!nextItem) {
      setError('Enter an item before adding it.');
      return;
    }

    if (nextItem.includes(',')) {
      setError('Commas are not allowed in default items.');
      return;
    }

    if (nextItem.length > MAX_ITEM_LENGTH) {
      setError(`Items must be ${MAX_ITEM_LENGTH} characters or fewer.`);
      return;
    }

    if (items.length >= MAX_ITEMS) {
      setError(`You can add up to ${MAX_ITEMS} items.`);
      return;
    }

    if (items.some(item => item.toLowerCase() === nextItem.toLowerCase())) {
      setError('This item is already in the list.');
      return;
    }

    onChange([...items, nextItem]);
    setDraftItem('');
    setError('');
  };

  const removeItem = (itemToRemove) => {
    onChange(items.filter(item => item !== itemToRemove));
    setError('');
  };

  const onKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      addItem();
    }
  };

  return (
    <div className='mt-3'>
      <div className='flex flex-row gap-2'>
        <input
          value={draftItem}
          onChange={(e) => { setDraftItem(e.target.value); setError(''); }}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          className='bg-[#DCE0FF] p-3 rounded-lg outline-none font-heebo w-[520px] font-light'
        />
        <button
          type='button'
          onClick={addItem}
          className='px-5 py-2 hover:bg-opacity-100 bg-opacity-80 cursor-pointer bg-[#3C5BD2] text-white font-heebo rounded-lg'
        >
          Add
        </button>
      </div>

      {error && <span className='font-heebo text-sm text-red-600 mt-2 inline-block'>{error}</span>}

      <div className='flex flex-wrap gap-2 mt-3 max-w-[670px]'>
        {items.map(item => (
          <div key={item} className='flex items-center gap-2 bg-[#3C5BD2] bg-opacity-10 rounded-lg px-3 py-2'>
            <span className='font-heebo font-light'>{item}</span>
            <button
              type='button'
              onClick={() => removeItem(item)}
              className='font-heebo text-[#3C5BD2] font-medium px-1 hover:opacity-70'
              aria-label={`Remove ${item}`}
            >
              x
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditableItemList;
